// extracted by mini-css-extract-plugin
module.exports = {"root":"ReviewsInfo_root__c4PYV","new":"ReviewsInfo_new__LahZ7","averageRating":"ReviewsInfo_averageRating__11AqA","iconStar":"ReviewsInfo_iconStar__2Ejuk"};